import { createAsyncThunk } from '@reduxjs/toolkit';
import request from '../../request/request';

export const createTenant = createAsyncThunk('createTenant', async (object, { rejectWithValue }) => {
  const response = await request('/api/v1/tenants-create', { method: 'POST' , body: object, auth: true});

  if (response) {
    return response;
  }
  const { error } = response;
  throw rejectWithValue(error || 'Something went wrong');
});